import { render, staticRenderFns } from "./AddOrEditGeograficCitiesForm.vue?vue&type=template&id=a1b478a4"
import script from "./AddOrEditGeograficCitiesForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditGeograficCitiesForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditGeograficCitiesForm.vue?vue&type=style&index=0&id=a1b478a4&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports